// survey-types.constant.ts
export const SurveyType = {
    GENERAL: { value: "0", name: "General" },
    DECLINE_LOAN: { value: "1", name: "Decline Loan" },
};

// question-types.constant.ts
export const QuestionType = {
    RADIO: { value: 0, name: "Radio" },
    SELECT: { value: 1, name: "Select" },
    MULTIPLE: { value: 2, name: "Multiple" },
    TEXT: { value: 3, name: "Text" },
    SELECT_MULTIPLE: { value: 4, name: "Multi Select Dropdown" },
};

export const QuestionRequiredStatus = {
    REQUIRED: { value: "0", name: "Required", color: "success" },
    OPTIONAL: { value: "1", name: "Optional", color: "danger" },
};